import InputAutocomplete from '@components/InputAutocomplete';
import { FormGroup, FormLabel } from '@mui/material';
import { ITalentSearchFilterOption } from '../types';

interface CountryFilterProps {
  name: string;
  options: ITalentSearchFilterOption[];
}

const CountryFilter = ({ name, options }: CountryFilterProps) => {
  const mappedOptions = options.map((option) => ({
    value: option.value,
    label: `${option.label} (${option.count})`,
  }));

  return (
    <FormGroup>
      <FormLabel>Pays</FormLabel>
      <InputAutocomplete
        id={name}
        name={name}
        multiple
        options={mappedOptions}
      />
    </FormGroup>
  );
};

export default CountryFilter;
